<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
/* global echarts, $config */
import resize from './mixins/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '600px'
    },
    chartData: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler (val) {
        this.setOptions(val)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
    setOptions (expectedData) {
      this.chart.setOption({
        backgroundColor: 'transparent',
        title: {
          text: '',
          subtext: '',
          left: 'center',
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          trigger: 'item'
        },
        bmap: {
          center: $config.mapCenter,
          zoom: $config.zoomLevel,
          roam: true,
          mapStyle: {
            styleJson: [
              {
                'featureType': 'water',
                'elementType': 'all',
                'stylers': {
                  'color': '#044161'
                }
              },
              {
                'featureType': 'land',
                'elementType': 'all',
                'stylers': {
                  'color': '#283443'
                }
              },
              {
                'featureType': 'boundary',
                'elementType': 'geometry',
                'stylers': {
                  'color': '#064f85'
                }
              },
              {
                'featureType': 'railway',
                'elementType': 'all',
                'stylers': {
                  'visibility': 'off'
                }
              },
              {
                'featureType': 'highway',
                'elementType': 'geometry',
                'stylers': {
                  'color': '#004981'
                }
              },
              {
                'featureType': 'highway',
                'elementType': 'geometry.fill',
                'stylers': {
                  'color': '#005b96',
                  'lightness': 1
                }
              },
              {
                'featureType': 'highway',
                'elementType': 'labels',
                'stylers': {
                  'visibility': 'off'
                }
              },
              {
                'featureType': 'arterial',
                'elementType': 'geometry',
                'stylers': {
                  'color': '#004981'
                }
              },
              {
                'featureType': 'arterial',
                'elementType': 'geometry.fill',
                'stylers': {
                  'color': '#00508b'
                }
              },
              {
                'featureType': 'poi',
                'elementType': 'all',
                'stylers': {
                  'visibility': 'off'
                }
              },
              {
                'featureType': 'green',
                'elementType': 'all',
                'stylers': {
                  'color': '#056197',
                  'visibility': 'off'
                }
              },
              {
                'featureType': 'subway',
                'elementType': 'all',
                'stylers': {
                  'visibility': 'off'
                }
              },
              {
                'featureType': 'manmade',
                'elementType': 'all',
                'stylers': {
                  'visibility': 'off'
                }
              },
              {
                'featureType': 'local',
                'elementType': 'all',
                'stylers': {
                  'visibility': 'off'
                }
              },
              {
                'featureType': 'arterial',
                'elementType': 'labels',
                'stylers': {
                  'visibility': 'off'
                }
              },
              {
                'featureType': 'boundary',
                'elementType': 'geometry.fill',
                'stylers': {
                  'color': '#029fd4'
                }
              },
              {
                'featureType': 'building',
                'elementType': 'all',
                'stylers': {
                  'color': '#1a5787'
                }
              },
              {
                'featureType': 'label',
                'elementType': 'labels.text.fill',
                'stylers': {
                  'color': '#009e96'
                }
              },
              {
                'featureType': 'label',
                'elementType': 'labels.text.stroke',
                'stylers': {
                  'color': '#283443'
                }
              }
            ]
          }
        },
        series: [
          {
            name: '车位数',
            type: 'effectScatter',
            // type: 'scatter',
            coordinateSystem: 'bmap',
            data: expectedData,
            encode: {
              value: 2
            },
            showEffectOn: 'emphasis',
            rippleEffect: {
              brushType: 'stroke'
            },
            hoverAnimation: true,
            symbolSize: $config.symbolSize,
            tooltip: {
              formatter: function (params) {
                // var res
                // res = '<div><span style="font-weight: bold;">大车位：</span>' + params.value[2] + '个</div>' +
                //   '<div><span style="font-weight: bold;">小车位：</span>' + params.value[3] + '个</div>'
                return ''
              }
            },
            label: {
              formatter: '{b}',
              position: 'right',
              fontSize: '18',
              fontWeight: 'bold',
              show: true
            },
            itemStyle: {
              color: '#ddb926',
              shadowBlur: 10,
              shadowColor: '#333'
            },
            emphasis: {
              label: {
                show: true
              }
            }
          }
        ]
      })
      this.chart.on('finished', function () {
        var bdElements = document.getElementsByClassName(' anchorBL')
        if (bdElements && bdElements.length) {
          for (var i = 0; i < bdElements.length; i++) {
            bdElements[i].style.display = 'none'
          }
        }
      })
      this.chart.on('click', (params) => {
        this.$emit('parkChange', params.dataIndex, params.value[4])
      })
    }
  }
}
</script>
</style>


// WEBPACK FOOTER //
// src/components/index/mapChart.vue